import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'
// import extractApiData from 'Helpers/extractApiData'

const endpoints = (baseURL => {
  return {
    setSendingType: (idList, idSending) =>
      `${baseURL}/api/list/${idList}/sending/${idSending}/setsendingtype`,
    getListSenders: params =>
      `${baseURL}/api/senders/search?${encodeParams(params)}`
  }
})(process.env.BESMSSEND_URL)

export const beSmsSendSetSendingType = (idList, idSending, params) => {
  const url = endpoints.setSendingType(idList, idSending)

  return apiWrapper({
    method: 'put',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(params)
  }).then(extractApiData)
}

export const beSmsSendGetListSenders = (params, body) => {
  const url = endpoints.getListSenders(params)

  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(body)
  }).then(extractApiData)
}
